'use client';

import * as React from 'react';

import * as ToggleGroup from '@radix-ui/react-toggle-group';

import { cn } from '../../lib/utils';

export interface SegmentedOption {
    value: string;
    label: React.ReactNode;
}

interface SegmentedProps {
    value: string;
    onValueChange: (value: string) => void;
    options: SegmentedOption[];
    className?: string;
    'aria-label'?: string;
}

/**
 * Single-select segmented control (clean pill toggle). Used for theme,
 * script/iframe, and the ticker %/¢ display mode.
 */
export function Segmented({ value, onValueChange, options, className, ...props }: SegmentedProps) {
    return (
        <ToggleGroup.Root
            type="single"
            value={value}
            onValueChange={(next) => {
                if (next) onValueChange(next);
            }}
            className={cn(
                'inline-flex items-center gap-0.5 rounded-x30 border border-stroke-x30 bg-container-x30 p-0.5',
                className,
            )}
            aria-label={props['aria-label']}
        >
            {options.map((option) => (
                <ToggleGroup.Item
                    key={option.value}
                    value={option.value}
                    className={cn(
                        'typ-emphasis-x20 inline-flex items-center justify-center gap-1.5 rounded-x20 px-3 py-1 text-text-x20 transition-colors',
                        'hover:text-text-x10 focus-visible:outline-none',
                        'data-[state=on]:bg-surface-x10 data-[state=on]:text-text-x10 data-[state=on]:shadow-x10',
                    )}
                >
                    {option.label}
                </ToggleGroup.Item>
            ))}
        </ToggleGroup.Root>
    );
}
